import { AxiosError } from 'axios';
import { authHeader } from 'services';
import { IReport } from 'types/Report';

import { Api } from './api/axios.service';

const getReport = async (): Promise<IReport[]> => {
  try {
    const { data } = await Api.get<IReport[]>(`/company/report`, {
      headers: authHeader(),
    });

    return data;
  } catch (reason) {
    const { response } = reason as AxiosError<{ error: string }>;
    throw new Error(
      response?.data?.error || 'Não foi possível listar o relatório'
    );
  }
};

export const ReportService = {
  getReport,
};

